// Targeting type enum for database storage. Extracted from
// apps/web/data/southpaw/targeting.ts so messaging model types (and the
// @punchup/data managers) can reference it without importing the Supabase-heavy
// targeting query module. The app-side targeting.ts re-exports this enum.
export enum TargetingType {
  VENUE = 1,
  GUEST_LIST = 2,
  WAITLIST = 3,
  CONTACT_LIST = 4,
  COMPOSITE = 5,
}
